import { render, staticRenderFns } from "./FollowUp.vue?vue&type=template&id=e2155b6a&scoped=true&"
import script from "./FollowUp.vue?vue&type=script&lang=ts&"
export * from "./FollowUp.vue?vue&type=script&lang=ts&"
import style0 from "./FollowUp.vue?vue&type=style&index=0&id=e2155b6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2155b6a",
  null
  
)

/* custom blocks */
import block0 from "./FollowUp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports